import React, {useEffect} from 'react';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import Container from 'components/layout/Container';
import Checkmark from 'components/ui/icon/Checkmark';
import useAnalyticEvent from 'hooks/useAnalyticsEveent';

import './WarrantyPage.scss';

function WarrantyPage() {
  useAnalyticEvent('quick_view', {});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="warranty-page">
      <Container extraClassName="warranty-page__wrapper">
        <section className="warranty-page__section warranty-page__section_first">
          <Title
            extraClassName="warranty-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Гарантия и&nbsp;компенсация
          </Title>
          <p className="warranty-page__section-description">
            Прежде, чем давать доступ к&nbsp;сервису и&nbsp;вашим заказам, Руки
            проверяют компетенцию каждого независимого мастера. Также
            мы&nbsp;предоставляем мастерам техкарты на&nbsp;все виды услуг,
            а&nbsp;у&nbsp;клиентов собираем отзывы и&nbsp;следим
            за&nbsp;метриками удовлетворенности. В&nbsp;большинстве случаев
            этого достаточно, чтобы контролировать качество работы независимых
            мастеров.
          </p>
          <p className="warranty-page__section-description">
            Но&nbsp;бывает, что стрелец в&nbsp;козероге, и&nbsp;мастер выполняет
            работу некачественно или царапает свеженькую плитку. Тогда
            мы&nbsp;берем ответственность мастера в&nbsp;свои руки и&nbsp;даем
            гарантию 12&nbsp;месяцев и&nbsp;компенсацию причиненного мастером
            ущерба до&nbsp;250&nbsp;000&nbsp;₽.
          </p>
        </section>

        <section className="warranty-page__section warranty-page__section_second">
          <Title
            extraClassName="warranty-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Сроки решения
          </Title>

          <div className="warranty-page__flex-layout">
            <ul className="warranty-page__list">
              {[
                {
                  title: <>17 дней</>,
                  description: <>Организуем переделку по гарантии</>,
                },
                {
                  title: <>30 дней</>,
                  description: <>Компенсируем ущерб</>,
                },
              ].map((item, index) => (
                <li key={index} className="warranty-page__list-item">
                  <Checkmark
                    color="#00f"
                    extraClassName="warranty-page__list-item-bullet"
                  />

                  <span className="warranty-page__list-item-title">
                    {item.title}
                  </span>

                  <span className="warranty-page__list-item-description">
                    {item.description}
                  </span>
                </li>
              ))}
            </ul>

            <div className="warranty-page__info-card">
              В&nbsp;90% случаев мы&nbsp;справляемся за&nbsp;22&nbsp;дня
            </div>
          </div>
        </section>

        <section className="warranty-page__section warranty-page__section_third">
          <Title
            extraClassName="warranty-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Напишите нам, всё решим
          </Title>

          <div className="warranty-page__flex-layout">
            <div>
              <p className="warranty-page__section-description">
                Напишите нам в&nbsp;чат поддержки или сообщите о&nbsp;проблеме
                по&nbsp;телефону 8&nbsp;495&nbsp;134-06-96
              </p>

              <p className="warranty-page__section-description warranty-page_mobile">
                Укажите номер заказа и/или телефон, на&nbsp;который его
                оформляли
              </p>

              <div className="warranty-page__buttons">
                <a
                  href="https://t.me/handsrubot"
                  className="warranty-page__button warranty-page__button-telegram"
                >
                  Telegram
                </a>

                {window.Intercom ? (
                  <button
                    className="warranty-page__button warranty-page__button warranty-page__button-intercom"
                    onClick={() => {
                      window.Intercom('show');
                    }}
                  >
                    Intercom
                  </button>
                ) : (
                  <a
                    className="warranty-page__button warranty-page__button warranty-page__button-intercom"
                    href="https://intercom.help/ruki/ru/"
                  >
                    Intercom
                  </a>
                )}
              </div>
            </div>

            <div className="warranty-page__tooltip">
              Укажите номер заказа и/или телефон, на&nbsp;который его оформляли
            </div>
          </div>
        </section>

        <section className="warranty-page__section warranty-page__section_forth">
          <Title
            extraClassName="warranty-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Процесс решения
          </Title>

          <ul className="warranty-page__list">
            {[
              {
                description: (
                  <>Запустим машинку поддержки сразу после обращения.</>
                ),
              },
              {
                description: (
                  <>
                    Через 5&nbsp;дней вернёмся с&nbsp;планом действий: соберём
                    документы, поможем услышать мастера, при необходимости
                    подключим экспертов.
                  </>
                ),
              },
              {
                description: (
                  <>За&nbsp;17&nbsp;дней организуем ремонт по&nbsp;гарантии.</>
                ),
              },
              {
                description: (
                  <>За&nbsp;12&nbsp;дней согласуем сумму компенсации.</>
                ),
              },
              {
                description: <>За&nbsp;22&nbsp;дня вы&nbsp;получите деньги.</>,
              },
            ].map((item, index) => (
              <li key={index} className="warranty-page__list-item">
                <span className="warranty-page__list-item-bullet warranty-page__list-item-bullet_number">
                  {index + 1}.
                </span>

                <span className="warranty-page__list-item-description">
                  {item.description}
                </span>
              </li>
            ))}
          </ul>
        </section>

        <section className="warranty-page__section warranty-page__section_fifth">
          <Title
            extraClassName="warranty-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Напишите нам в&nbsp;любом случае
          </Title>

          <p className="warranty-page__section-description">
            Есть замечания по&nbsp;сервису, времени подбора мастера, работе
            приложения?
            <br />
            Напишите нам&nbsp;&mdash; так мы&nbsp;узнаем, что сделать лучше.
          </p>

          <div className="warranty-page__buttons">
            <a
              href="https://t.me/handsrubot"
              className="warranty-page__button warranty-page__button-telegram"
            >
              Telegram
            </a>

            {window.Intercom ? (
              <button
                className="warranty-page__button warranty-page__button warranty-page__button-intercom"
                onClick={() => {
                  window.Intercom('show');
                }}
              >
                Intercom
              </button>
            ) : (
              <a
                className="warranty-page__button warranty-page__button warranty-page__button-intercom"
                href="https://intercom.help/ruki/ru/"
              >
                Intercom
              </a>
            )}
          </div>
        </section>
      </Container>
    </main>
  );
}

export default WarrantyPage;
